// @flow
import React from 'react';
import { connect } from 'react-redux';
import NotificationSettingsCheckbox from './NotificationSettingsCheckbox';
import NotificationSettingsRowTemplate from './NotificationSettingsRowTemplate';
import setNotificationSettingPush from '../state/setNotificationSettingPush';
import setNotificationSettingEmail from '../state/setNotificationSettingEmail';

type Props = {
    title: string,
    pushKey: string,
    emailKey: string,
    settingsEmailLookup: {},
    settingsPushLookup: {},
    token: string,
    dispatch: () => any
};

const NotificationSettingsRow = ({
    title,
    pushKey,
    emailKey,
    settingsEmailLookup,
    settingsPushLookup,
    token,
    dispatch
}: Props) => {
    const titleColumn = <div>{title}</div>;

    let pushColumn = null;
    let pushState = null;
    if (pushKey) {
        pushState = settingsPushLookup[pushKey];
        pushColumn = (
            <NotificationSettingsCheckbox
                checked={pushState}
                onChange={(enabled: boolean) => {
                    dispatch(
                        setNotificationSettingPush(pushKey, enabled, token)
                    );
                }}
            />
        );
    }
    let emailColumn = null;
    let emailState = null;
    if (emailKey) {
        emailState = settingsEmailLookup[emailKey];
        emailColumn = (
            <NotificationSettingsCheckbox
                checked={emailState}
                onChange={(enabled: boolean) => {
                    dispatch(
                        setNotificationSettingEmail(emailKey, enabled, token)
                    );
                }}
            />
        );
    }

    return (
        <NotificationSettingsRowTemplate
            firstColumn={titleColumn}
            secondColumn={pushColumn}
            thirdColumn={emailColumn}
        />
    );
};

const mapStateToProps = (state: {}, ownProps: any) => {
    return {
        ...ownProps,
        settingsEmailLookup:
            state.notificationSettings.notificationSettingsEmailLookup,
        settingsPushLookup:
            state.notificationSettings.notificationSettingsPushLookup
    };
};

export default connect(mapStateToProps)(NotificationSettingsRow);
